import {AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild} from '@angular/core';

@Component({
    selector: 'm4u-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements AfterViewInit {
    // @ts-ignore
    private LabelLines: string[] = [];

    @Input() IconClass: string;
    @Input() IconColor: string;
    @Input() set Label(value: string) {
        this.LabelLines = value ? value.split('\n') : [];
    }

    @ViewChild('tooltipIcon') tooltipEl: ElementRef;

    constructor(private renderer: Renderer2) {

    }

    ngAfterViewInit(): void {
        this.InitTooltipContainer();
    }

    public InitTooltipContainer(): string {
        this.renderer.addClass(this.tooltipEl.nativeElement, 'dx-icon');
        this.renderer.addClass(this.tooltipEl.nativeElement, 'tooltip-icon-fonst-size');

        if (this.IconClass) {
            if (this.IconClass.includes('mdi')) {
                this.renderer.addClass(this.tooltipEl.nativeElement, 'mdi');
            }

            this.renderer.addClass(this.tooltipEl.nativeElement, this.IconClass);
        } else {
            this.renderer.addClass(this.tooltipEl.nativeElement, 'mdi');
            this.renderer.addClass(this.tooltipEl.nativeElement, 'mdi-information');
        }

        if (this.IconColor) {
            this.renderer.setStyle(this.tooltipEl.nativeElement, 'color', this.IconColor);
            return;
        }

        this.renderer.addClass(this.tooltipEl.nativeElement, 'tooltip-icon-color');
    }
}
